var scroll = {
    data: {
        documentHeight: 0,
        windowHeight: 0,
        scrollTop: 0,
        scrollHeight: 0,
        elements: [],
    },
    oldData: {
        documentHeight: null,
        windowHeight: null,
        scrollTop: null,
    },
    tick: function (callback) {
        const fn = window.requestAnimationFrame ||
            window.webkitRequestAnimationFrame ||
            window.mozRequestAnimationFrame ||
            window.msRequestAnimationFrame ||
            window.oRequestAnimationFrame ||
            function (callback) {
                window.setTimeout(callback, 1000 / 60)
            }
        fn(callback)
    },
    hasChanged: function () {
        return this.data.documentHeight != this.oldData.documentHeight
            || this.data.windowHeight != this.oldData.windowHeight
            || this.data.scrollTop != this.oldData.scrollTop
    },
    getProgress: function (el) {
        const distance = this.data.scrollTop - el.offsetTop
        var pc = distance / (el.offsetHeight / 100)
        return Math.min(100, Math.max(0, pc))
    },
    getThresholds: function () {
        let thresholds = [0]
        let numSteps = 100
        for (let i = 1.0; i <= numSteps; i++) {
            let ratio = i / numSteps
            thresholds.push(ratio)
        }
        return thresholds
    },
    update: function () {
        this.data.documentHeight = document.documentElement.scrollHeight
        this.data.windowHeight = window.innerHeight
        this.data.scrollTop = window.scrollY
        if (this.hasChanged()) {
            this.data.scrollHeight = (this.data.documentHeight - this.data.windowHeight)

            this.data.elements.forEach(el => {
                var pc = this.getProgress(el.targetEl)
                el.style.setProperty('--targetprogress', pc)
                if (pc >= el.percent) {
                    el.classList.add(el.class)
                } else {
                    el.classList.remove(el.class)
                }
            })
            this.oldData.documentHeight = this.data.documentHeight
            this.oldData.windowHeight = this.data.windowHeight
            this.oldData.scrollTop = this.data.scrollTop
        }
        this.tick(this.update.bind(this))
    },
    observed: function (entries, obs) {
        entries.forEach(entry => {
            var el = entry.target
            var initiator = el.initiator
            var pc = entry.intersectionRatio * 100
            initiator.style.setProperty('--targetseen', pc)
            el.style.setProperty('--seen', pc)
            if (pc >= initiator.percent) {
                initiator.classList.add(initiator.class)
            } else {
                initiator.classList.remove(initiator.class)
            }
        })
    },
    init: function () {
        this.data.elements = Array.prototype.slice.call(document.querySelectorAll('[data-scroll-progress]'), 0)
        this.data.elements.forEach(el => {
            el.percent = el.dataset.scrollProgress || 10
            el.class = el.dataset.scrollClass || 'on'
            el.target = el.dataset.scrollTarget || 'body'
            el.targetEl = document.querySelector(el.target)
            el.targetEl.initiator = el
        })
        this.update()


        var observer = window.IntersectionObserver ? new IntersectionObserver(this.observed.bind(this), {
            threshold: this.getThresholds()
        }) : null
        var els = Array.prototype.slice.call(document.querySelectorAll('[data-scroll-inview]'), 0)
        els.forEach(el => {
            el.percent = el.dataset.scrollInview || 10
            el.class = el.dataset.scrollToggle || 'on'
            el.target = el.dataset.scrollTarget || 'body'
            el.targetEl = document.querySelector(el.target)
            el.targetEl.initiator = el
            if (observer) observer.observe(el.targetEl)
        })
    }
}
export default scroll